






import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import BankId from '../assets/bankid.svg';
import BankIdNo from '../assets/bankid-no.svg';
import NemId from '../assets/nemid.svg';
import NemIdOrg from '../assets/nemid-organization.svg';
import MitIdDark from '../assets/mitid-dark.svg';
import type { EIdIconType } from '../types/enums/eid-icon-type';

export default defineComponent({
  components: {
    BankId,
    BankIdNo,
    NemId,
    NemIdOrg,
    MitIdDark,
  },
  props: {
    type: {
      type: String as PropType<EIdIconType>,
      required: true,
    },
  },
});
